import { Image, StyleSheet } from 'react-native'

import { colors } from '@zet/design-system'
import { Stack } from '@zet/design-system/layout'
import { B2 } from '@zet/design-system/typography'

import { brandsI18n } from '../../localization'

type HeaderProps = {
  logoUrl?: string
  partnerId?: string
  metadata?: {
    partnerPrimaryColor?: string
    applicationType?: string
    partnerHeaderTextColor?: string
  }
}

export const Header: React.FC<HeaderProps> = ({
  logoUrl,
  partnerId,
  metadata,
}) => {
  return (
    <Stack
      className={`border-grays-40 py-4/2 border-b px-3`}
      style={{
        backgroundColor: metadata?.partnerPrimaryColor || '#FFFFFF',
      }}
    >
      <Image
        source={{
          uri: logoUrl
            ? logoUrl
            : `https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/brandLogos/${partnerId}.png`,
        }}
        style={[styles.logo, partnerId == '299' && styles.hdfcLogo]}
      />
      <B2
        className="mt-2"
        style={{ color: metadata?.partnerHeaderTextColor || colors.grays[80] }}
      >
        {partnerId === '261' || metadata?.applicationType === 'LOAN'
          ? brandsI18n.t('loans.formHeader')
          : brandsI18n.t('axis.formHeader')}
      </B2>
    </Stack>
  )
}

const styles = StyleSheet.create({
  logo: {
    resizeMode: 'contain',
    width: 100,
    height: 35,
  },
  hdfcLogo: {
    width: 150,
    height: 27,
  },
})
